<template>
  <v-form ref="form">
    <v-container grid-list-md>
      <v-layout v-if="!ui.loading">
        <v-flex xs12>
          <v-toolbar color="pink" dark>
            <v-icon>loupe</v-icon>
            <v-toolbar-title>Championship Details</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field v-model="championship.name" :rules="ui.required" label="Championship Title"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field v-model="championship.venue" :rules="ui.required" label="Venue"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-combobox v-model="championship.genderCategory" :items="['Female','Male']" label="Gender Category" :rules="ui.required"></v-combobox>
                </v-flex>
                <v-flex xs6>
                  <v-combobox v-model="championship.ageCategory" :items="['Masters','Junior','SubJunior','Senior']" label="Age Category" :rules="ui.required"></v-combobox>
                </v-flex>
                <v-flex xs6>
                  <v-dialog ref="dateDialog" v-model="ui.dateOpen" :return-value.sync="championship.date" persistent lazy full-width width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field v-model="formattedDate" label="Championship Date" readonly v-on="on" :rules="ui.required"></v-text-field>
                    </template>
                    <v-date-picker v-model="championship.date" scrollable :min="ui.minDate">
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="ui.dateOpen = false">Cancel</v-btn>
                      <v-btn flat color="primary" @click="$refs.dateDialog.save(championship.date)">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-flex>
                <v-flex xs6>
                  <v-checkbox v-model="championship.isRegistrationsOpen" label="Team Registrations Allowed"></v-checkbox>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red lighten-1" dark @click="cancel">Cancel</v-btn>
              <v-btn color="primary" @click="save" :loading="ui.loading">{{championship.id?"Update":"Create"}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout v-if="ui.loading">
        <v-flex>
          <v-card>
            <div class="text-xs-center pa-3">
              <v-progress-circular indeterminate color="green"></v-progress-circular>
            </div>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-snackbar v-model="ui.snackbar" :color="ui.snackbarMode" :timeout="5000">
      <span>{{ ui.feedback }}</span>
      <v-btn dark flat @click="ui.snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-dialog v-model="ui.showConfirm" lazy full-width width="50%">
      <v-card>
        <v-card-title class="headline">Are you sure?</v-card-title>

        <v-card-text>There are unsaved changes which will be lost if you leave this page. Are you sure you want to go back to championship list?</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" flat="flat" @click="ui.showConfirm = false">Cancel</v-btn>

          <v-btn color="green darken-1" flat="flat" @click="backToChampionshipList">Yes, show championship list</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form>
</template>

<script>
import moment from "moment";

export default {
  data: function() {
    return {
      championship: {
        id:"",
        name: "",
        venue: "",
        date: "",
        isRegistrationsOpen: false,
        ageCategory: "",
        genderCategory: ""
      },
      ui: {
        loading: false,
        minDate: moment().toISOString(),
        valid: null,
        dateOpen: false,
        required: [
          function(x) {
            return x ? true : "This field is required";
          }
        ],
        snackbar: false,
        feedback: "",
        snackbarMode: "success",
        showConfirm: false,
        isDirty: false
      }
    };
  },
  computed: {
    formattedDate: function() {
      return this.championship.date
        ? moment(this.championship.date).format("DD-MMM-YYYY")
        : "";
    },
    formattedRCDate: function() {
      return this.championship.registrationClosingDate
        ? moment(this.championship.registrationClosingDate).format(
            "DD-MMM-YYYY"
          )
        : "";
    }
  },
  methods: {
    save: function() {
      if (!this.$refs.form.validate()) return;

      var me = this;
      var champ = this.championship;
      var endpoint = this.$api("championships");
      me.ui.loading = true;
      var task = this.championship.id
        ? endpoint.put(champ)
        : endpoint.post(champ);
      task
        .then(function() {
          me.showsnackBar("Championship Saved", "success");
          me.$router.push({ name: "championship-list" });
        })
        .catch(function(xhr) {
          me.showsnackBar(
            xhr.statusJSON && (xhr.statusJSON.feedback || xhr.statusJSON.title)
              ? xhr.statusJSON.feedback || xhr.statusJSON.title
              : "An error occured",
            "error"
          );
        })
        .finally(function() {
          me.ui.loading = false;
        });
    },
    showsnackBar: function(msg, mode) {
      this.ui.feedback = msg;
      this.ui.snackbar = true;
      this.ui.snackbarMode = mode || "info";
    },
    cancel: function() {
      if (this.ui.isDirty) this.ui.showConfirm = true;
      else this.backToChampionshipList();
    },
    backToChampionshipList: function() {
      this.$router.push({ name: "championship-list" });
    },
    load: function(id) {
      var me = this;
      me.ui.loading = true;
      this.$api("championships")
        .get({ id: id })
        .then(function(resp) {
          me.championship = resp;
          me.championship.date = me.championship.date
            ? me.championship.date.substr(0, 10)
            : "";
          me.championship.registrationClosingDate = me.championship
            .registrationClosingDate
            ? me.championship.registrationClosingDate.substr(0, 10)
            : "";
        })
        .catch(function() {
          me.showsnackBar("Failed to load championship details", "error");
        })
        .finally(function() {
          me.ui.isDirty = false;
          me.ui.loading = false;
        });
    }
  },
  watch: {
    championship: {
      deep: true,
      handler: function() {
        this.ui.isDirty = true;
      }
    }
  },
  mounted: function() {
    if (this.$route.params.id) this.load(this.$route.params.id);
  },
  beforeRouteUpdate: function(to, from, next) {
    if (to.params.id) this.load(to.params.id);
    next();
  }
};
</script>

<style>
</style>
